import { useEffect, useState } from 'react';
import axios from 'axios';
import { Scale, Shield, FileText, BookOpen, Loader2 } from 'lucide-react';
import { API } from '@/App';
import SiteHeader from '@/components/SiteHeader';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const ICONS = { page_legal: Scale, page_privacy: Shield, page_conditions: FileText, page_conditions_annuaire: BookOpen };

export default function SiteTextPage({ section }) {
  const [page, setPage] = useState(null);
  const Icon = ICONS[section] || FileText;

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/site-content/${section}`)
      .then(r => setPage({ ...(r.data?.data || {}), updated_at: r.data?.updated_at }))
      .catch(() => setPage({}));
  }, [section]);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Roboto', sans-serif" }} data-testid={`site-text-page-${section}`}>
      <SiteHeader />
      <SEO title={page?.title || 'SFOALC'} description={page?.subtitle || page?.title || ''} />
      <section className="pt-12 pb-14 px-4" style={{ background: '#eaf6fc' }}>
        <div className="max-w-4xl mx-auto text-center">
          <Icon className="mx-auto mb-5 text-[#35AFE4]" size={56} />
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900" style={{ fontFamily: "'Barlow', sans-serif" }} data-testid="site-text-title">
            {page?.title}
          </h1>
          {page?.subtitle && <p className="mt-4 text-base text-gray-600">{page.subtitle}</p>}
        </div>
      </section>
      <section className="py-14 px-4">
        <div className="max-w-3xl mx-auto">
          {!page ? (
            <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#35AFE4]" size={28} /></div>
          ) : (
            <>
              <div className="rich-content" data-testid="site-text-content" dangerouslySetInnerHTML={{ __html: page.content || '' }} />
              {page.updated_at && (
                <p className="mt-12 pt-6 border-t border-gray-100 text-xs text-gray-400" data-testid="site-text-updated">
                  Dernière mise à jour : {new Date(page.updated_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
              )}
            </>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
